// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-item[data-v-79d52c92] {\n  font-family: var(--interfaceFontTypeface, inherit);\n  color: var(--interfaceFontColor, var(--text-gray-500));\n}\n.filter-item[data-v-79d52c92] {\n  font-weight: var(--interfaceFontWeight, 700);\n}\n.filter-item[data-v-79d52c92]:hover,\n.filter-item[data-v-79d52c92]:focus,\n.filter-item--selected[data-v-79d52c92] {\n  color: var(--text-blue-600);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
